import type { MapBody } from '@shared/mapDefinitions.js';

// White until the layer's setup picks another; drawn here, so credits nobody.
const def: MapBody<'color'> = {
  color: [255, 255, 255, 1],
  attribution: [],
};

export default def;
